var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box",style:(`background-color: ${_vm.background}`)},[_c('div',{class:`${_vm.scrollable?'animate click':'click'}`,style:(`color:${_vm.color}`),on:{"click":_vm.getLastNotice}},[_vm._v(" "+_vm._s(_vm.noticeContent || _vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }